import { StepWizardStep } from '../../../commons/StepWizard/StepWizard.types';
import LoginCommercialForm from './LoginCommercialForm/LoginCommercialForm';

export const loginCommercialSteps: StepWizardStep[] = [
  {
    step: 1,
    component: LoginCommercialForm,
    title: 'Connexion <primary>commercial</primary>',
    subtitle: 'Entrez vos identifiants',
  },
];
